import {useEffect, useState} from 'react';
import {isLogin, setLocalStorage} from '@/utils/main';
import globalNavigation from '@/utils/global-navigation';
import globalDomains from '@/utils/global-domains';
import {sendPostMessage} from './useSearchInpFocus';
import {throwDialog} from '@/utils/ui/dialog';

const useSoopiManager = (
  iframeVisible,
  closeIframe,
  updateSoopiTicket,
  isDragging,
  handleClose,
) => {
  const [isDisplay, setIsDisplay] = useState(false);
  const [theme, setTheme] = useState(false);
  const [isOpenedGnb, setIsOpenedGnb] = useState(false);

  globalNavigation.handleAuthorized((_, soopiTicket) => {
    if (!isLogin()) {
      return;
    }
    updateSoopiTicket(soopiTicket);
    setIsDisplay(soopiTicket.toggle === 'on');
    setLocalStorage('floating_persona_size', soopiTicket.icon);
  });

  globalNavigation.handleSoopiMenuToggle((isActive) => {
    if (!isActive) {
      closeIframe();
    }
    setIsDisplay(isActive);
  });

  useEffect(() => {
    if (iframeVisible) {
      sendThemeMessage(theme);
    }
  }, [theme]);

  const sendThemeMessage = (themeValue) => {
    const message = JSON.stringify({
      type: 'theme',
      value: themeValue,
    });
    const frame = document.getElementById('soopi-frame');

    frame.contentWindow.postMessage(message, globalDomains.SOOPI_AFREECATV);
  };

  globalNavigation.handleThemeChanged(({value}) => {
    if (value === 'dark' || value === 'light') {
      setTheme(value);
    }
  });

  globalNavigation.handleDropDownMenuOpen((data) => {
    if (!data) {
      return;
    }

    const isOpened = Object.values(data).some((isOpened) => isOpened === true);

    setIsOpenedGnb(isOpened);
  });

  useEffect(() => {
    const popupHandler = (type, data) => {
      if (type === 'SOOPI_PROMOTION_POPUP') {
        openSoopLandingModal();
      }
    };

    globalNavigation.handlePopupRequest(popupHandler);
  }, []);

  const handleCloseSoopiBtn = (e) => {
    e.stopPropagation();
    if (!isDragging) {
      globalNavigation.setSoopiToggle(false);
      setIsDisplay(false);
    }
  };

  const openSoopLandingModal = async () => {
    await throwDialog(
      'soopi/SoopiLandingModal',
      {
        handleClose,
      },
      {isCustomDialog: true},
    );
  };

  useEffect(() => {
    if (isOpenedGnb) {
      sendPostMessage('opened_gnb');
    } else {
      sendPostMessage('closed_gnb');
    }
  }, [isOpenedGnb]);

  return {
    isDisplay,
    handleCloseSoopiBtn,
  };
};

export default useSoopiManager;
